import PropTypes from 'prop-types';
import React from 'react';

/**
 *  Describe the component
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FilterTitle(_ref) {
  let {
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    "data-cmp": "filterTitle",
    ...rest,
    children: /*#__PURE__*/_jsx("h2", {
      className: "col-xs-12 text-bold text-gray-base text-size-300 text-size-sm-400",
      children: title
    })
  });
}
export default FilterTitle;